import { render, staticRenderFns } from "./App.vue?vue&type=template&id=216ae30f&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=216ae30f&prod&lang=scss&scoped=true"
import style1 from "theme/css/main.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ae30f",
  null
  
)

export default component.exports